import React from "react"
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import PublicForm from "./pages/PublicForm"
import LoginPage from "./pages/LogInPage"
import PublicUserPage from "./pages/PublicUserPage"
import PubUserSearch from "./pages/PubUserSearch"
import PubCart from "./pages/PubCart"
import PubBag from "./pages/PubBag"
import PubOrder from "./pages/PubOrder"
import CategoryPage from "./pages/CategoryPage"
import PubCategory from "./pages/PubCategory"
import ForgotPassword from "./pages/ForgotPassword"
import PubProfile from "./pages/PubProfile"
import ProductPage from "./pages/ProductPage"
import Login from "./pages/Login"
import PageFA from "./pages/PageFA"
import UsersPage from "./pages/UsersPage"
import CompletePage from "./pages/CompletePage"
import PendingPage from "./pages/PendingPage"
import BillPage from "./pages/BillPage"
import TermsPage from "./pages/TermsPage"
import ProtectedRoute from "../src/ProtectedRoute"
import ProtRoute from "../src/ProtRoute"
import PageNotFound from "./pages/PageNotFound"
import Product from "./pages/Product"

export default function App()
{
  return (
    <BrowserRouter>
    
      
        <Routes>

          
        <Route path="/" element={<HomePage />} />
        <Route path="publicForm" element={<PublicForm />} />     
        <Route  path="login" element={<LoginPage />} />
        <Route path="forgotPassword" element={<ForgotPassword />}/>
        <Route path="termsPage" element={<TermsPage/>}/>
        <Route path="publicUser"  element={<ProtectedRoute> <PublicUserPage /> </ProtectedRoute>} ></Route>
        <Route path="pubUserSearch"  element={<ProtectedRoute> <PubUserSearch /> </ProtectedRoute>} ></Route>
        <Route path="pubCart"  element={<ProtectedRoute> <PubCart /> </ProtectedRoute>} ></Route>
        <Route path="pubBag" element= {<ProtectedRoute> <PubBag /> </ProtectedRoute>}></Route>
        <Route path="pubOrder" element={<ProtectedRoute> <PubOrder /> </ProtectedRoute>}></Route>
        <Route path="category" element={ <CategoryPage /> }/>
        <Route path="pubCategory" element={<ProtectedRoute> <PubCategory /> </ProtectedRoute>}/>
        <Route path="pubProfile" element={<ProtectedRoute> <PubProfile/> </ProtectedRoute>}/> 
        <Route path="productPage" element={<ProtectedRoute> <ProductPage/> </ProtectedRoute>}/>
        <Route path="loginFa" element={<Login/>}/>
        <Route path="adminPage" element={<ProtRoute> <PageFA/> </ProtRoute>  }/> 
        <Route path="usersPage" element={<ProtRoute>  <UsersPage/> </ProtRoute> }/>
        <Route path="completePage" element={<ProtRoute> <CompletePage/> </ProtRoute>}/>
        <Route path="pendingPage" element={<ProtRoute> <PendingPage/> </ProtRoute>  }/>
        <Route path="billPage" element={<ProtRoute> <BillPage/> </ProtRoute> }/>
        <Route path="product" element={<ProtRoute> <Product/> </ProtRoute> }/>
        <Route path="*" element={<PageNotFound/>}/>
       
        </Routes>
     
    
    </BrowserRouter>
  )
}